function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import MaterialCheckbox from "../../../../../__snowpack__/pkg/@mui/material/Checkbox.js";
import MaterialTableRow from "../../../../../__snowpack__/pkg/@mui/material/TableRow.js";
import React, {useCallback, useState} from "react";
import TableCell from "../table-cell/table-cell.component.js";
function TableRow({
  headers,
  checked,
  item,
  onRowSelect,
  selectable,
  fixSelect,
  ...rest
}) {
  const [hovered, setHover] = useState(false);
  const bxShadow = headers.map((cells) => cells.fixLeft).includes(true);
  const handleRowSelect = useCallback(() => {
    if (onRowSelect) {
      onRowSelect(item.id);
    }
  }, [item.id, onRowSelect]);
  return /* @__PURE__ */ React.createElement(MaterialTableRow, _extends({
    onMouseOver: () => setHover(true),
    onMouseLeave: () => setHover(false)
  }, rest), selectable && /* @__PURE__ */ React.createElement(TableCell, {
    padding: "checkbox",
    $bxShadow: !bxShadow,
    $fixLeft: fixSelect,
    $selected: checked,
    $hover: hovered,
    $fixWidth: 0
  }, /* @__PURE__ */ React.createElement(MaterialCheckbox, {
    color: "primary",
    checked,
    onChange: handleRowSelect
  })), headers.map((header, index) => {
    const fixWidth = selectable && header.fixLeft && fixSelect ? 46 : 0;
    return /* @__PURE__ */ React.createElement(TableCell, {
      $fixWidth: fixWidth,
      $hidden: header.hidden,
      $selected: checked,
      $hover: hovered,
      $bxShadow: bxShadow,
      $fixLeft: header.fixLeft,
      $fixRight: header.fixRight,
      key: index
    }, item[header.name]);
  }));
}
export default /* @__PURE__ */ React.memo(TableRow);
